export default "__VITE_PUBLIC_ASSET__2d38e6c1__"